<script>
	let { title = 'Indow For Your Windows' } = $props();
</script>

{#snippet circleNumber(num = 0)}
	<div class="shrink-0">
		<span
			class="
     inline-flex size-15 items-center justify-center rounded-full border-4
     border-white text-[2rem] font-bold text-white
   "
		>
			{num}
		</span>
	</div>
{/snippet}

<h2 class="mb-8">{title}</h2>
<ol
	class="
   flex max-w-lg list-none flex-col gap-6 pl-0 leading-5 text-indow-grey-dark
 "
>
	<li class="flex gap-6">
		{@render circleNumber(1)}
		<p class="text-indow-grey-dark">
			<span class="font-bold">Request</span> a Free Estimate. We'll provide you with
			a preliminary estimate based on your basic window dimensions. It's quick and
			easy!
		</p>
	</li>
	<li class="flex gap-6">
		{@render circleNumber(2)}
		<p class="text-indow-grey-dark">
			<span class="font-bold">Measure</span> your windows with our easy-to-use laser
			measurement kit. We'll guide you through the simple process, ensuring a perfect
			fit.
		</p>
	</li>
	<li class="flex gap-6">
		{@render circleNumber(3)}
		<p class="text-indow-grey-dark">
			<span class="font-bold">Customize</span> your inserts to match your needs and
			your aesthetic, with tubing colors that seamlessly blend into your space.
		</p>
	</li>
	<li class="flex gap-6">
		{@render circleNumber(4)}
		<p class="text-indow-grey-dark">
			<span class="font-bold">Transform</span> your space with custom-crafted inserts
			shipped directly to your home, ready to fit perfectly in your windows.
		</p>
	</li>
</ol>
